<section class="hero">
  <div class="hero-copy">
    <h1 class="white">Schedule a <span class="mdg-green">Demo</span></h1>
    <h3 class="white">We will reach out, and show you how it works!</h3>
  </div>
</section>
<div class="container-fluid section-2 bg-mdg-blue py-5 px-3">
  <div class="row my-5 py-2">
    <div class="col-md-12">
      <div style="max-width: 800px; margin: 0 auto">
        <app-static-footer></app-static-footer>
      </div>
    </div>
  </div>
</div>
